import user from './user'
import app from './app'
import pagination from './pagination'
import actionDetails from './action-details'

export default {
  user,
  app,
  pagination,
  actionDetails
}